import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // <-- Importa o useNavigate
import { auth, googleProvider } from "../firebase";
import { signInWithPopup, signInWithEmailAndPassword } from "firebase/auth";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate(); // <-- Instancia o redirecionamento

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      alert("Login com Google realizado!");
      navigate("/admin"); // <-- Redireciona para Admin após login
    } catch (error) {
      console.error("Erro ao fazer login com Google:", error);
      alert(`Erro: ${error.message}`);
    }
  };

  const handleEmailLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Login realizado com sucesso!");
      navigate("/admin"); // <-- Redireciona para Admin após login
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      alert(`Erro ao fazer login: ${error.message}`);
    }
  };


  return (
    <div className="h-screen flex justify-center items-center bg-gray-100">
      <div className="p-6 bg-white shadow-md rounded-md text-center w-96">
        <h2 className="text-2xl font-bold mb-4">Área Restrita</h2>

        <form onSubmit={handleEmailLogin} className="flex flex-col">
          <input
            type="email"
            placeholder="Digite seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-2 border rounded-md mb-2"
            required
          />
          <input
            type="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border rounded-md mb-4"
            required
          />
          <button
            type="submit"
            className="bg-green-500 text-white px-4 py-2 rounded-md"
          >
            Entrar com E-mail
          </button>
        </form>

        <hr className="my-4" />

        <button
          onClick={handleGoogleLogin}
          className="mt-2 bg-blue-500 text-white px-4 py-2 rounded-md w-full"
        >
          Entrar com Google
        </button>
      </div>
    </div>
  );
}
